'use client'

import Section, { SectionProps } from '@lyra/core/components/Section'
import React from 'react'

import TransferButton from '../common/TransferButton'

type Props = SectionProps

export default function HomeTransferPromptSection({ ...sectionProps }: Props) {
  return (
    <Section {...sectionProps}>
      <Section.Header
        title="Fund Trading Account"
        subtitle={`You have tokens in your funding account. Transfer balances to your first trading account to start trading.`}
      />
      <Section.XStack>
        <TransferButton isCta defaultFromSubaccountId="funding" size="lg" minWidth={140} />
      </Section.XStack>
    </Section>
  )
}
